
import {
    CFormInput, CFormLabel, CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CPopover, CFormTextarea, CAccordion,
    CAccordionItem,
    CAccordionHeader,
    CAccordionBody,
} from '@coreui/react'
import Select from 'react-select'
import { Plus } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat'

const questionFields = [
    { key: "rollLeftAndRight", label: "Roll left and right" },
    { key: "sitToLying", label: "Sit to lying" },
    { key: "lyingToSittingOnSideOfBed", label: "Lying to sitting on side of bed" },
    { key: "sitToStand", label: "Sit to stand" },
    { key: "chairToBedTransfer", label: "Chair to bed transfer" },
    { key: "toiletTransfer", label: "Toilet transfer" },
    { key: "walk10Feet", label: "Walk 10 feet" },
    { key: "ambulatoryAids", label: "Ambulatory aids" }
];


const commonOptions = [
    { label: "Independent", value: "independent" },
    { label: "Set up or cleanup assistance", value: "setup_or_cleanup_assistance" },
    { label: "Supervision or touching assistant", value: "supervision_or_touching_assistant" },
    { label: "Partial moderate assistant", value: "partial_moderate_assistant" },
    { label: "Substantial maximal assistant", value: "substantial_maximal_assistant" },
    { label: "Dependent", value: "dependent" },
    { label: "Patient refused", value: "patient_refused" }
];

const ambulatoryOptions = [
    { label: "None", value: "none" },
    { label: "Wheelchair", value: "wheelchair" },
    { label: "Cane", value: "cane" },
    { label: "Walker", value: "walker" }
];


const ProviderMobilityTreatment = ({ noteStructureRef, diagnosisName,showDataIfNoteIsFollowUp=true, setNoteRefTrigger }) => {
    const [visible, setVisible] = useState(false)
    const [date, setDate] = useState('');

    const [selectedData, setSelectedData] = useState({
        rollLeftAndRight: [],
        sitToLying: [],
        lyingToSittingOnSideOfBed: [],
        sitToStand: [],
        chairToBedTransfer: [],
        toiletTransfer: [],
        walk10Feet: [],
        ambulatoryAids: []
    });

    const handleChange = (selectedOptions, key) => {
        setSelectedData((prev) => ({
            ...prev,
            [key]: selectedOptions || []
        }));
    };

    // const updateNoteStructure = (updatedScore, updatedDate) => {
    //     noteStructureRef.current = {
    //         ...noteStructureRef.current,
    //         ['MobilityAssessment']: {
    //             ...noteStructureRef.current['MobilityAssessment'],
    //             [diagnosisName]: {
    //                 date: updatedDate,
    //                 score: updatedScore,
    //             },
    //         },
    //     };
    // };

    useEffect(() => {

        if (noteStructureRef.current?.MobilityAssessment) {
            const existingData = noteStructureRef.current.MobilityAssessment;
            setSelectedData(existingData.assessment || {
                rollLeftAndRight: [],
                sitToLying: [],
                lyingToSittingOnSideOfBed: [],
                sitToStand: [],
                chairToBedTransfer: [],
                toiletTransfer: [],
                walk10Feet: [],
                ambulatoryAids: []
            });
            setDate(existingData.date || '');
        }
    }, [])
    const updateNoteStructure = (data, updatedDate) => {
        noteStructureRef.current = {
            ...noteStructureRef.current,
            ['MobilityAssessment']: {
                date: updatedDate || '',
                assessment: data || {},
            },
            assessment: {
                ...noteStructureRef.current.assessment,
                [diagnosisName]: {
                    ...noteStructureRef.current.assessment[diagnosisName],
                    ['MobilityAssessment']: {
                        date: updatedDate || '',
                        assessment: data || {},
                    },
                }
            },
        };
        setNoteRefTrigger((prev) => prev + 1);

    }
    const handleSaveData = () => {
        updateNoteStructure(selectedData, date);
        setVisible(false)
    }
    const handleDateChange = (e) => {
        const newDate = e
        setDate(newDate);
        updateNoteStructure(selectedData, newDate);
    };
    console.log("selectedData Mobility Assessment:MDS - GG", selectedData)
    return (
        <>
        <CAccordion>
         <CAccordionItem className='border' >
                                                    <CAccordionHeader>Mobility Assessment</CAccordionHeader>
                                                    <CAccordionBody>
                                                         <div>
            <div>
                <div >
                    {/* <div className='d-flex align-items-center gap-2 '>
                        <div>
                            <b className=''>Mobility Assessment:MDS - GG </b>
                        </div>
                        <div className='mt-2'>
                            { <CFormLabel
                                className="d-flex flex-column align-items-center justify-content-center shadow "
                                onClick={() => setVisible((p) => !p)}
                                style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "20px",
                                    background: "var(--ui-color-primary, #2b7cd3)",
                                    cursor: "pointer",
                                }}
                            >
                                <Plus className="text-white" strokeWidth={2} size={15} />
                            </CFormLabel>}



                        </div>

                    </div>
                    <hr /> */}
                    {/* <div>
                        <CAccordion alwaysOpen>
                            <CAccordionItem itemKey={1}>
                                <CAccordionHeader ><div className='d-flex align-items-center gap-2 '>
                                    <div>
                                        <b className=''>Mobility Assessment:MDS - GG </b>
                                    </div>
                                    <div className=''>
                                        <CFormLabel
                                            className="d-flex flex-column align-items-center justify-content-center shadow "
                                            onClick={() => setVisible((p) => !p)}
                                            style={{
                                                width: "30px",
                                                height: "30px",
                                                borderRadius: "20px",
                                                background: "var(--ui-color-primary, #2b7cd3)",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <Plus className="text-white" strokeWidth={2} size={15} />
                                        </CFormLabel>
                                      


                                    </div>

                                </div></CAccordionHeader>
                                <CAccordionBody>
                                    {questionFields.map((field) => {
                                        const selectedLabels = selectedData[field.key]?.map((item) => item.label).join(", ");
                                        return selectedLabels ? (
                                            <div key={field.key} className="mb-2">
                                                <strong>{field.label}:</strong> {selectedLabels}
                                            </div>
                                        ) : null;
                                    })}
                                </CAccordionBody>
                            </CAccordionItem>
                        </CAccordion>
                    </div> */}

                    { 
                    <div className="" style={{
                        fontSize: "14px",
                        // resize: "none",

                        color: '#2C384AF2',
                        // width: '45vw',
                    }}>
                        {
                            date && selectedData && (
                                <div>
                        <div className='mb-2 text-white'><strong>Date :</strong> {date}</div>
                        {questionFields.map((field) => {
                            const selected = selectedData[field.key];
                            if (selected && selected.length > 0) {
                                const values = selected.map((item) => item.label).join(", ");
                                return (
                                    <div key={field.key} className="mb-2 text-white" >
                                        <strong>{field.label}:</strong> {values}
                                    </div>
                                );
                            }
                            return null;
                        })}
                        </div>
                            )
                        }
                    </div>}

                    <div>
                        <CModal
                            backdrop="static"
                            size='lg'
                            visible={visible}
                            onClose={() => setVisible(false)}
                        >
                            <CModalHeader>
                                <CModalTitle id="StaticBackdropExampleLabel">
                                    Mobility Assessment:MDS - GG
                                </CModalTitle>
                            </CModalHeader>

                            <CModalBody
                            
                            >
                                <div className="px-4 py-3"
                                 >

                                    <div className="container " style={{ height: '500px', overflowY: 'auto' }}>
                                        <div className="mb-4 ">

                                            <div className="d-flex align-items-center gap-3">
                                                <CFormLabel className="fw-medium mb-0">Date:</CFormLabel>
                                                {/* <CFormInput
                                                    type="date"
                                                    value={date}
                                                    onChange={(e) => handleDateChange(e)}
                                                    // disabled={type === "note" ? false : true}
                                                    style={{
                                                        width: "180px",
                                                        height: "32px",
                                                        fontSize: "14px",
                                                        padding: "4px 8px",
                                                    }}
                                                /> */}
                                                <CustomDatePickingFormat
                                                value={date}
                                                onChange={(e)=>{handleDateChange(e)}}
                                                />
                                            </div>
                                        </div>
                                        {questionFields.map((field) => (
                                            <div className="row mb-3" key={field.key}>
                                                <CFormLabel className="fw-medium mb-1">{field.label}</CFormLabel>
                                                <Select
                                                    isMulti
                                                    options={field.label === "Ambulatory aids" ? ambulatoryOptions : commonOptions}
                                                    value={selectedData[field.key]}
                                                    onChange={(selected) => handleChange(selected, field.key)}
                                                />
                                            </div>
                                        ))}
                                    </div>


                                </div>
                            </CModalBody>


                            <CModalFooter
                            style={{
                                borderTop:"1px solid #f1f1f1"
                            }}
                            className='m-0 p-0 py-2 pb-4 px-4'
                            >
                                <CButton variant='outline' color="secondary" onClick={() => setVisible(false)}>
                                    Close
                                </CButton>
                                <CButton variant='outline' color="primary" onClick={() => handleSaveData()}>
                                    Save
                                </CButton>
                            </CModalFooter>
                        </CModal>
                    </div>
                </div>
            </div>
        </div>
                                                    </CAccordionBody>
                                                    </CAccordionItem>
                                                    </CAccordion>
       
        </>

    )
}

export default ProviderMobilityTreatment
